import LogCannon from '@ace-clublabs/log-cannon';
import axios from 'axios';
import { IGetPolicyPaymentInfoRequest, ErrorType } from '../../shared/types';
import CookieHelper from '../../utils/cookieHelper';
import { GetPolicyPaymentInfo } from '../contracts';
import { createAxiosConfig } from '../mockHelper';

export const GetPolicyPaymentInfoApi =
  (endpoint: string): GetPolicyPaymentInfo =>
  async ({ policyNumber, clubCode, appFlow, brokerRegion }: IGetPolicyPaymentInfoRequest) => {
    try {
      const scenario = CookieHelper.getCookie('scenario');
      LogCannon.blast('GetPolicyPaymentInfoApi scenario', { scenario });
      LogCannon.blast('GetPolicyPaymentInfoApi start', { endpoint });

      let modifiedEndPoint = clubCode ? `${endpoint}/${policyNumber}/${clubCode}` : `${endpoint}/${policyNumber}`;
      modifiedEndPoint = appFlow ? `${modifiedEndPoint}?appFlow=${appFlow}` : modifiedEndPoint;
      modifiedEndPoint = brokerRegion ? `${modifiedEndPoint}&brokerRegion=${brokerRegion}` : modifiedEndPoint;

      const { data, status } = await axios.get(modifiedEndPoint, createAxiosConfig(scenario, modifiedEndPoint));
      if (data?.error) {
        const { code } = data?.error;
        return Promise.reject({
          code,
          type: ErrorType.SOFT_ERROR,
        });
      }

      LogCannon.blast('GetPolicyPaymentInfoApi success');
      return Promise.resolve({ ...data, status: status });
    } catch (error: any) {
      LogCannon.error('GetPolicyPaymentInfoApi error', error);
      const message = error.message;
      let statusCode;
      statusCode = error?.response?.status ?? (parseInt(message?.substring(message.length - 3)) || undefined);

      if (statusCode && statusCode < 500) {
        return Promise.reject({
          message,
          type: statusCode === 403 && error?.response?.data?.pxEvent ? ErrorType.BOT_ERROR : ErrorType.SOFT_ERROR,
        });
      }

      return Promise.reject({
        message,
        type: ErrorType.SYSTEM_ERROR,
      });
    }
  };
